module.exports = __webpack_public_path__ + "static/media/imagemColetoresHospital2.4e943708.png";